import {useProjectDetails} from "./useProjectDetails";

export function useProjectDetailsHeaderData(projectDetails: ReturnType<typeof useProjectDetails>) {
	return {
		loadStatus: projectDetails.loadStatus,
		customer: projectDetails.project?.customerName,
		site: projectDetails.project?.site,
		salesperson: projectDetails.project?.salesperson
	}
}